// @flow
import React, { Component } from 'react'
import agents from '../../../../data/agents'
import AgentData from '../AgentData'

type Props = {
  openContactModal: func,
  propertyAgentId: string
}

class PropertyAgents extends Component {
  props: Props

  render() {
    const propertyAgent = agents.find(
      (a) => String(a.agentId) === String(this.props.propertyAgentId)
    )
    if (propertyAgent) {
      return (
        <AgentData
          agent={propertyAgent}
          openContactModal={this.props.openContactModal}
        />
      )
    }
    return (
      <div>
        {agents.map((agent) => (
          <AgentData
            key={agent.id}
            agent={agent}
            openContactModal={this.props.openContactModal}
          />
        ))}
      </div>
    )
  }
}

export default PropertyAgents



// WEBPACK FOOTER //
// ./src/views/Property/components/PropertyAgents/index.js